import { Component, OnInit, ViewChild } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import { MyProfileModel } from 'src/shared/model/UserProfile';

import { AuthService } from 'src/shared/service/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AbstractDataProvider } from '../AbstractDataProvider';
import { DynamicModalService } from '../ui-components/dynamic-modals/dynamic-modal.service';
import { JqueryDialogService } from '../ui-components/jquery-dialog/jquery-dialog.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import {getErrorMessageText} from '../helper';

@Component({
  selector: 'app-deactivate-user-popup',
  templateUrl: './deactivate-user-popup.component.html',
  styleUrls: ['./deactivate-user-popup.component.scss']
})
export class DeactivateUserPopupComponent implements OnInit {

  userProfileEntity: MyProfileModel = new MyProfileModel();
  display = false;
  alertMessage: string;
  userType: string;
  deactivationDate: any;
  @ViewChild('Date') date;
  subjectOnClose: Subject<any>;

  constructor(
    public rest: RestService,
    private authService: AuthService,
    private dynamicModalService: DynamicModalService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private jqueryDialogService: JqueryDialogService,
    private abstractDataProvider: AbstractDataProvider) {
  }


  ngOnInit() {
  }

  onConfirm() {
    this.display = false;
  }

  save(): void {

    if (!this.date.Value) {
      this.display = true;
      this.alertMessage = 'Please enter deactivation date';
      return;
    }

    if (!this.todayOrEalier(new Date(this.date.Value))) {
      this.display = true;
      this.alertMessage = 'Deactivation date cannot be in the future';
      return;
    }
    this.userProfileEntity = JSON.parse(JSON.stringify(this.authService.currentUserProfileEntity));
    this.userProfileEntity.DeactivatedDate = this.date.Value;
    this.abstractDataProvider.postData(this.userProfileEntity, 'api/Accounts/DeactivateUser').subscribe(
      (posts: any) => {
        this.display = true;
        this.alertMessage = posts.Data.AlertMsgs[0];
        this.dynamicModalService.subject.next(null);
        this.subjectOnClose.next(posts);
      },
      error => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      }
    );
  }

  cancel() {
    this.dynamicModalService.subject.next(null);
    this.subjectOnClose.next(null);
  }

  private todayOrEalier(date: Date): boolean {
    const now = new Date(new Date().toDateString());
    return date <= now;
  }


}
